export const FavoritesState = {
  idle: 'idle',
  failed: 'failed',
  favoritesLoading: 'loading',
  favoritesLoaded: 'loaded',
  favoriteIdsSet: 'favoriteIdsSet',
};

export const WhenSearchState = {
  idle: 'idle',
  loading: 'loading',
  failed: 'failed',
  loaded: 'loaded',
}
